import { Controller, useFormContext } from 'react-hook-form';

import { Button } from 'flyt';

import { AkselLocale, Chips, ToggleGroup } from 'components/form/aksel';

const NOTHING_PICKED = '__none__';

export default function ButtonGroup({
	name,
	label,
	options = [],
	exclusive = false,
	clearable = false,
	// eslint-disable-next-line no-unused-vars -- Unused legacy prop.
	size = undefined,
	...rest
}) {
	const {
		control,
		formState: { disabled: formDisabled },
	} = useFormContext();

	return (
		<Controller
			name={name}
			control={control}
			render={({ field: { onChange, value } }) =>
				exclusive ? (
					<AkselLocale>
						<div className="flex items-center gap-2">
							<ToggleGroup
								size="small"
								value={value || NOTHING_PICKED}
								aria-label={label}
								{...rest}
								// Legacy overrides expect (event, value); Aksel emits value only.
								onChange={nextValue =>
									rest.onChange
										? rest.onChange(null, nextValue)
										: onChange(nextValue)
								}
							>
								{options.map(option => (
									<ToggleGroup.Item
										key={option.value}
										value={option.value}
										label={option.label}
										disabled={formDisabled || rest.disabled}
									/>
								))}
							</ToggleGroup>

							{clearable && (
								<Button
									type="button"
									variant="ghost"
									size="sm"
									title={`Tøm ${label.toLowerCase()}`}
									disabled={
										formDisabled || rest.disabled || !value
									}
									onClick={() => onChange(null)}
								>
									Tøm
								</Button>
							)}
						</div>
					</AkselLocale>
				) : (
					<AkselLocale>
						<Chips aria-label={label} {...rest}>
							{options.map(option => {
								const picked = (value ?? []).includes(
									option.value
								);

								return (
									<Chips.Toggle
										key={option.value}
										selected={picked}
										disabled={formDisabled || rest.disabled}
										onClick={() =>
											onChange(
												picked
													? (value ?? []).filter(
															held =>
																held !==
																option.value
														)
													: [
															...(value ?? []),
															option.value,
														]
											)
										}
									>
										{option.label}
									</Chips.Toggle>
								);
							})}
						</Chips>
					</AkselLocale>
				)
			}
		/>
	);
}
